import React, {FC, useMemo} from 'react';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";

export const RatingsIcon: FC<{isSmall?: boolean}> = ({isSmall}) => {

    const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    if (!is1440BP && !smHeight && !isSmall) return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_11012_14900" fill="white">
            <rect x="4" y="19.75" width="6" height="8.25" rx="0.75"/>
        </mask>
        <rect x="4" y="19.75" width="6" height="8.25" rx="0.75" stroke="#909090" strokeWidth="3" mask="url(#path-1-inside-1_11012_14900)"/>
        <mask id="path-2-inside-2_11012_14900" fill="white">
            <rect x="13" y="12.25" width="6" height="15.75" rx="0.75"/>
        </mask>
        <rect x="13" y="12.25" width="6" height="15.75" rx="0.75" stroke="#909090" strokeWidth="3" mask="url(#path-2-inside-2_11012_14900)"/>
        <mask id="path-3-inside-3_11012_14900" fill="white">
            <rect x="22" y="4" width="6" height="24" rx="0.75"/>
        </mask>
        <rect x="22" y="4" width="6" height="24" rx="0.75" stroke="#909090" strokeWidth="3" mask="url(#path-3-inside-3_11012_14900)"/>
    </svg>


    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_11009_7836" fill="white">
                <rect x="2" y="15.125" width="5" height="6.875" rx="0.625"/>
            </mask>
            <rect x="2" y="15.125" width="5" height="6.875" rx="0.625" stroke="#909090" strokeWidth="2" mask="url(#path-1-inside-1_11009_7836)"/>
            <mask id="path-2-inside-2_11009_7836" fill="white">
                <rect x="9.5" y="8.875" width="5" height="13.125" rx="0.625"/>
            </mask>
            <rect x="9.5" y="8.875" width="5" height="13.125" rx="0.625" stroke="#909090" strokeWidth="2" mask="url(#path-2-inside-2_11009_7836)"/>
            <mask id="path-3-inside-3_11009_7836" fill="white">
                <rect x="17" y="2" width="5" height="20" rx="0.625"/>
            </mask>
            <rect x="17" y="2" width="5" height="20" rx="0.625" stroke="#909090" strokeWidth="2" mask="url(#path-3-inside-3_11009_7836)"/>
        </svg>
    )
}
import React, {FC, useMemo} from 'react';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";

export const RatingsIcon: FC<{isSmall?: boolean}> = ({isSmall}) => {

    const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    if (!is1440BP && !smHeight && !isSmall) return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_11012_14900" fill="white">
            <rect x="4" y="19.75" width="6" height="8.25" rx="0.75"/>
        </mask>
        <rect x="4" y="19.75" width="6" height="8.25" rx="0.75" stroke="#909090" strokeWidth="3" mask="url(#path-1-inside-1_11012_14900)"/>
        <mask id="path-2-inside-2_11012_14900" fill="white">
            <rect x="13" y="12.25" width="6" height="15.75" rx="0.75"/>
        </mask>
        <rect x="13" y="12.25" width="6" height="15.75" rx="0.75" stroke="#909090" strokeWidth="3" mask="url(#path-2-inside-2_11012_14900)"/>
        <mask id="path-3-inside-3_11012_14900" fill="white">
            <rect x="22" y="4" width="6" height="24" rx="0.75"/>
        </mask>
        <rect x="22" y="4" width="6" height="24" rx="0.75" stroke="#909090" strokeWidth="3" mask="url(#path-3-inside-3_11012_14900)"/>
    </svg>


    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_11009_7836" fill="white">
                <rect x="2" y="15.125" width="5" height="6.875" rx="0.625"/>
            </mask>
            <rect x="2" y="15.125" width="5" height="6.875" rx="0.625" stroke="#909090" strokeWidth="2" mask="url(#path-1-inside-1_11009_7836)"/>
            <mask id="path-2-inside-2_11009_7836" fill="white">
                <rect x="9.5" y="8.875" width="5" height="13.125" rx="0.625"/>
            </mask>
            <rect x="9.5" y="8.875" width="5" height="13.125" rx="0.625" stroke="#909090" strokeWidth="2" mask="url(#path-2-inside-2_11009_7836)"/>
            <mask id="path-3-inside-3_11009_7836" fill="white">
                <rect x="17" y="2" width="5" height="20" rx="0.625"/>
            </mask>
            <rect x="17" y="2" width="5" height="20" rx="0.625" stroke="#909090" strokeWidth="2" mask="url(#path-3-inside-3_11009_7836)"/>
        </svg>
    )
}
